import styled from 'styled-components';

export default styled.div`

  position: relative;
  
  &::-webkit-scrollbar {
    width: 1rem;
  }

  &::-webkit-scrollbar:horizontal{
    height: 1rem;
  }

  &::-webkit-scrollbar-track {
    background: transparent; 
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(98, 106, 146, 0.85);
    border-radius: 0.6rem;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgb(98,106,146);
  }


  display: block;

  ${props => props.isButton ? `
    &:hover {
      text-decoration: none;
    }
  ` : ''}

  ${props => props.backgroundImage ? 'background-image: url("'+props.backgroundImage+'");' : ''}
  ${props => props.thisStyling}
  ${props => props.customStyleWrapper}

  ${ props => props.lineClamp ?  `
      line-clamp: ${props.lineClamp};
      -webkit-line-clamp: ${props.lineClamp};
    `
  : ''}
  
  ${ props => props.isCurrent ? `
    &::after {
      cursor: pointer;
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border: 1px dotted rgba(111,88,255,1);
      z-index: -1;
    }
  ` : ''}
  ${props => props.isEditor && props.isHover ? 
    `
      &:hover {
        z-index: 3;
        cursor: pointer;
      }
     
      &:hover::after {
        cursor: pointer;
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border: 2px dotted rgba(111,88,255, 0.8);
        z-index: -1;
      }

    `
  : ''};

  ${ props => props.canDrag ? `
    cursor: grab;
  ` : ''}

  ${ props => props.isMouseDown ? `
  cursor: grabbing;
` : ''}

  ${ props => props.isBackgroundHidden ? `
    background-image: none;
  ` : ''}
  
`;